import { render, staticRenderFns } from "./Marketplace.vue?vue&type=template&id=2f4dc71c&scoped=true&"
import script from "./Marketplace.vue?vue&type=script&lang=ts&"
export * from "./Marketplace.vue?vue&type=script&lang=ts&"
import style0 from "./Marketplace.vue?vue&type=style&index=0&id=2f4dc71c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f4dc71c",
  null
  
)

export default component.exports